import { object } from 'common/helpers'


export const initialState = {
  isFetching: false,
  isWaiting: false,
  steps: [],
  activeStepIndex: 0,
  products: [],
  selectedProducts: [],
  answers: {},
  tags: {},
  // answers: {
  //   age: { age: '55-64' },
  //   brands: { brands: 'designer' },
  //   categories: { another: '', bestsellers: true, newArrivals: true, topRated: '' },
  //   sex: { female: '', male: true, unisex: true },
  // },
}

export const setFetching = (state, payload) => (
  object.set(state, 'isFetching', payload)
)

export const setWaiting = (state, payload) => (
  object.set(state, 'isWaiting', payload)
)

export const setSteps = (state, payload) => (
  { ...state, steps: payload, isFetching: false }
)

export const updateStepIndex = (state, payload) => (
  object.set(state, 'activeStepIndex', payload)
)

export const setTagValueById = (state, payload) => {
  const { activeStepIndex } = state
  const { tags } = state.steps[activeStepIndex]

  const tagIndex = tags.findIndex((item) => item.id === payload)

  return object.updateIn(
    state,
    [ 'steps', activeStepIndex, 'tags', tagIndex ],
    (tag) => object.set(tag, 'value', !tag.value)
  )
}

export const setProducts = (state, payload) => (
  { ...state, products: payload, isFetching: false }
)

export const setSelectedProducts = (state, payload) => (
  { ...state, selectedProducts: payload }
)

export const updateAnswers = (state, payload) => (
  { ...state, answers: { ...state.answers, ...payload } }
)

export const updateAnswer = (state, { name, data }) => {
  const updateData = (oldData) => ({ ...(oldData || {}), ...data })

  return object.updateIn(state, [ 'answers', name ], updateData)
}

export const setAnswer = (state, { name, data }) => (
  object.setIn(state, [ 'answers', name ], data)
)

export const resetQuizData = () => initialState
